import script from "./about-us.vue?vue&type=script&setup=true&lang=js"
export * from "./about-us.vue?vue&type=script&setup=true&lang=js"

import "./about-us.vue?vue&type=style&index=0&id=05286984&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05286984"]])

export default __exports__